// extracted by css-extract-rspack-plugin
export default {"header":"Header-module__header__sJ0g1","avatar":"Header-module__avatar__AAPpl","title":"Header-module__title__QUX7e","smallTitle":"Header-module__smallTitle__oGi1V"};